module.exports = __webpack_public_path__ + "static/media/image-5.ec57b5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Algorithms/image-5.png
// module id = 250
// module chunks = 0